import styled from '@emotion/styled';
import { Modal } from '@spotify-internal/anchor-ds';
import {
  cssColorValue,
  FormGroup,
  screenSmMax,
} from '@spotify-internal/encore-web';
import { FieldLabel } from 'components/encore/form/Field';

export const ToggleContainer = styled(FormGroup)`
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 2fr min-content;
  align-items: center;
  padding-bottom: 0px;
  text-align: left;
`;
const PURPLE = '#5000b9';
const FOCUS_PURPLE = '#6732B9';
const FOCUS_GREY = '#dfe0e1';
const TEXT_GREY = '#7f8287';

export const VerticalAlignmentContainer = styled.div`
  display: flex;
  width: 30%;
`;

export const VerticalAlignmentLabel = styled.label`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 12px 0px;
  border: 2px solid;
  border-color: ${TEXT_GREY};
  border-radius: 10px;
  color: ${TEXT_GREY};
  background: white;
  cursor: pointer;

  :focus,
  :hover {
    border-color: ${TEXT_GREY};
    background: ${FOCUS_GREY};
  }

  input:checked + & {
    border-color: ${PURPLE};
    color: white;
    background: ${PURPLE};
    :focus,
    :hover {
      border-color: ${FOCUS_PURPLE};
      background: ${FOCUS_PURPLE};
    }
  }
`;

export const HiddenInput = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
`;

export const HorizontalJustificationLabel = styled.label`
  width: 37px;
  height: 27px;
  padding: 0px;
  cursor: pointer;

  svg,
  g {
    fill: ${TEXT_GREY};
  }
  :focus,
  :hover {
    svg,
    g {
      fill: #393b40;
    }
  }

  input:checked + & {
    svg,
    g {
      fill: ${PURPLE};
    }

    :focus,
    :hover {
      svg,
      g {
        fill: #945ee6;
      }
    }
  }
`;

export const ColorLabel = styled.label<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid;
  border-color: ${({ color }) => (color === '#ffffff' ? FOCUS_GREY : color)};
  border-radius: 20px;
  background-color: ${({ color }) => color};

  :focus,
  :hover {
    border-color: ${({ color }) => {
      switch (color) {
        case '#292f36':
        case '#979797':
        case PURPLE:
          return FOCUS_GREY;
        default:
          return TEXT_GREY;
      }
    }};
  }

  path {
    fill: ${({ color }) =>
      color === '#292f36' || color === PURPLE ? 'white' : PURPLE};
  }
`;

export const ColorPickerButton = styled.button`
  width: 40px;
  height: 40px;
  padding: 5px;
  border: 1px solid ${FOCUS_GREY};
  border-radius: 10px;
  background-color: #f2f2f3;
  :focus,
  :hover {
    border-color: ${TEXT_GREY};
  }
`;

export const InputContainer = styled.div`
  display: flex;
  margin: 4px;
`;

export const ContentOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.6);
`;

export const LoadingImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  background-color: ${cssColorValue('backgroundTintedBase')};
`;

export const ModalBody = styled(Modal.Body)`
  display: grid;
  grid-gap: 40px;
  grid-template-columns: 1fr max-content;

  @media (max-width: ${screenSmMax}) {
    grid-gap: 16px;
    grid-template-columns: 1fr;
  }
`;

export const ColorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 4px 0;
`;

export const FieldLabelContainer = styled(FieldLabel)`
  font-size: 1.2rem;
  line-height: 1.6rem;
`;
